import React, {useState} from 'react'
import EditButton from '../../../shared/actionButtons/EditButton'
import SkillsModal from './EditModals/SkillsModal'

type Props = {}

function UserSkills({}: Props) {
  const [skillsModal, setskillsModal] = useState(false)
  const handleSkillsModal = () => {
    setskillsModal(!skillsModal)
  }
  return (
    <div className='card-body pt-9 pb-0'>
      <SkillsModal editModal={skillsModal} handleEditModal={handleSkillsModal} />
      <div className='fs-4 fw-normal text-gray-800 my-4 '>
        <div className='d-flex '>
          <span className='fs-3 fw-bold '> Skills and Expertise</span>
          <EditButton handleEditModal={handleSkillsModal} className='mx-3' />
        </div>
        <div className='mt-6'></div>
        <div className='row'>
          <div className='col-md-2  d-flex align-items-center'>
            <span className='fw-bold fs-5'>Beginner</span>
          </div>
          <div className='col-md-auto d-flex align-items-center'>
            <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 mx-3 '>React</span>
            <span className='btn btn-sm btn-outline btn-secondary rounded   my-2 mx-3 '>React</span>
            <span className='btn btn-sm btn-outline btn-secondary rounded   my-2 mx-3 '>React</span>
            <span className='btn btn-sm btn-outline btn-secondary rounded   my-2 mx-3 '>React</span>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-2  d-flex align-items-center'>
            <span className='fw-bold fs-5'>Expert</span>
          </div>
          <div className='col-md-auto d-flex align-items-center'>
            <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 mx-3 '>React</span>
            <span className='btn btn-sm btn-outline btn-secondary rounded   my-2 mx-3 '>React</span>
            <span className='btn btn-sm btn-outline btn-secondary rounded   my-2 mx-3 '>React</span>
            <span className='btn btn-sm btn-outline btn-secondary rounded   my-2 mx-3 '>React</span>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-2  d-flex align-items-center'>
            <span className='fw-bold fs-5'>Advanced</span>
          </div>
          <div className='col-md-auto d-flex align-items-center'>
            <span className='btn btn-sm btn-outline btn-secondary rounded  my-2 mx-3 '>React</span>
            <span className='btn btn-sm btn-outline btn-secondary rounded   my-2 mx-3 '>React</span>
            <span className='btn btn-sm btn-outline btn-secondary rounded   my-2 mx-3 '>React</span>
            <span className='btn btn-sm btn-outline btn-secondary rounded   my-2 mx-3 '>React</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserSkills
